import { Translation } from '@ps/web-shared-components';

import { TXTWCL_WEXLL_BE_BACK_SOONX } from './CasinoMaintenance.messages.json';
import styles from './CasinoMaintenance.scss';
import { CasinoMaintenanceMessage } from './CasinoMaintenanceMessage/CasinoMaintenanceMessage';
import Logo from './assets/logo-pokerstars-casino.svg';
import PokerstarsAce from './assets/pokerstars-ace.png';

export const CasinoMaintenance = () => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img className={styles.ace} src={PokerstarsAce} alt="Pokerstars Ace" />
    </div>
    <div className={styles.textContainer}>
      <Translation {...TXTWCL_WEXLL_BE_BACK_SOONX}>
        {(message) => <h2 className={styles.title}>{message}</h2>}
      </Translation>
      <CasinoMaintenanceMessage />
      <Logo className={styles.logo} />
    </div>
  </div>
);

export default CasinoMaintenance;
